import { executeIdentify } from "./initializeIdentify/executeIdentify.js";
import { initializeDetails } from "./initializeIdentify/initializeDetails.js";
import { checkIfMarkupOrMeasure } from "./initializeIdentify/checkIfMarkupOrMeasure.js";
import { getExcludedLayerIds } from "./initializeIdentify/initializeExcludedLayerIds.js";
import { showPopup } from "./initializeIdentify/showPopup.js";
import { conditionalMapOptions } from "../util/importConditions";

conditionalMapOptions.excludedLayerIds = getExcludedLayerIds(); 
let WinGISMap; 
export default (_WinGISMap) => {
  WinGISMap = _WinGISMap;
  let features = initializeDetails(WinGISMap.view); 
  WinGISMap.view.when(() => {
    WinGISMap.view.on("click", (event) => {
      doIdentify(event); 
    });
    WinGISMap.view.on("key-down", function(event){
      if (event.key === "Enter"){
        doIdentify(event); 
      }
    }); 
  });
}

function doIdentify(event) {
  let userBusy = checkIfMarkupOrMeasure();
  if (!userBusy) {
    if (!event.mapPoint){
      event.mapPoint = WinGISMap.view.extent.center; 
    }
    WinGISMap.view.graphics = null;
    executeIdentify(event).then((featuresToDisplay) => {
      if (featuresToDisplay)
      {
        showPopup(featuresToDisplay, WinGISMap.view, event);

      }
    });
  }
}